import { AspectRatio, Box, BoxProps, Flex } from '@mantine/core'
import { useIsMobile } from 'hooks/useIsMobile'
import { useRouterExtend } from 'hooks/useRouterExtend'
import { HealthTool } from 'interfaces/types'
import { useIntl } from 'react-intl'
import useStyles from './index.styles'
import { assetImagePath, MAPPED_TOOL_TRACKING } from 'interfaces/constants'
import { getHelloSitesUrl } from 'api/utils/paths'
import { Button, Text } from '@hhgtech/hhg-components/mantine'
import AppIcon from 'components/atoms/icons/AppIcon'
import { ArrowRight } from '@hhgtech/icons/other'

export type CardProps = {
  tool: HealthTool
} & BoxProps

export const Card = ({
  tool,
  styles,
  classNames,
  className,
  ...boxProps
}: CardProps) => {
  const { locale } = useRouterExtend()
  const { formatMessage: f } = useIntl()
  const isMobile = useIsMobile()
  const { classes, cx, theme } = useStyles(undefined, {
    name: 'HealthToolTypeCategory__Card',
    styles,
    classNames,
  })
  return (
    <Box
      component="a"
      className={cx(className, classes.root)}
      href={tool.link.replace(/health-tools\/(?=health-tools\/)/, '')}
      data-event-category="Health Tool"
      data-event-action={MAPPED_TOOL_TRACKING[tool.template]}
      data-event-label={`${getHelloSitesUrl(locale)}${tool.link}`}
      {...boxProps}
    >
      <div className={classes.inner}>
        <div className={classes.body}>
          <AspectRatio ratio={1} className={classes.thumbnail}>
            <img
              loading="lazy"
              src={tool.icon || `${assetImagePath}/avatar.jpg`}
              alt={tool.title}
              style={{
                objectFit: 'contain',
              }}
            />
          </AspectRatio>
          <div className={classes.info}>
            <Text size="s3" color="#404040">
              {tool.title}
            </Text>
            {tool.isMobileAppTool && (
              <Flex gap={4}>
                <AppIcon size={16} />
                <Text
                  size="n1"
                  weight="regular"
                  color={theme.fn.primaryColor()}
                >
                  {f({ id: 'common.calcWithApp' })}
                </Text>
              </Flex>
            )}
            <Text
              className={classes.desc}
              size="p4"
              color="#404040"
              lineClamp={2}
            >
              {tool.subtitle}
            </Text>
          </div>
        </div>
        <div className={classes.action}>
          {isMobile ? (
            <ArrowRight size={18} color="currentColor" />
          ) : (
            <Button
              variant="tertiary"
              rightIcon={<ArrowRight size={18} color="currentColor" />}
              className={classes.btn}
              size="sm"
            >
              {f({ id: 'pnBannerWithOption.dueDateTool.btnLabel' })}
            </Button>
          )}
        </div>
      </div>

      {/* {tool.isMobileAppTool ? (
          <Box
            sx={(theme) => ({
              position: 'absolute',
              top: 8,
              right: 5,
              [theme.fn.smallerThan('sm')]: {
                top: 0,
                bottom: 0,
                display: 'flex',
                alignItems: 'center',
              },
            })}
          >
            <Phone size={isMobile ? 20 : 24} color={theme.colors.neutral[6]} />
          </Box>
        ) : (
          <ArrowRight className="arrow-icon" size={20} color="#8C8C8C" />
        )} */}
    </Box>
  )
}
